import { Grid } from '@material-ui/core';
import { Card, File, SectionHeader } from '../../blocks';
import { css } from '@emotion/react';

const OrderFilesCard = ({ order, attr, label }) => {
    return (
        <Card>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>{label}</SectionHeader>
            </Grid>
            <Grid item>
                {(order[attr] || []).map((file) => {
                    const src = file?.url || file;
                    return <File file={src} />;
                })}
            </Grid>
        </Card>
    );
};

export default OrderFilesCard;
